import createReducer from '../utils/createReducer';

const INITIAL_STATE = null;

export default createReducer('error', INITIAL_STATE, {
  log: (state, error) => error,
  dismiss: state => null,
});
